import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Flag1500UitFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='' htmlFor='checkbox-flag1500Uit' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='flag1500Uit'>
          {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flag1500Uit' label='1500 UIT' />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(Flag1500UitFormGroup)
